import { IHisInformationApplicable, instanceOfIHisInformationApplicable, IItem } from "../../document/items";
import { HisInformationItem } from "..";
import { IHisItemAction, IHisItemSelectable, IHisItemSet } from ".";
import { IDocumentEditable } from "../../../components/document/editor";
import { ScreenKinds } from "../../../domain/his/behavior";
import {
  IHisInformationGroupSource,
  HisInformationListItemGroupSource,
  HisInformationUserGroupSource,
  HisInformationDepartmentGroupSource
} from "../groupInput/HisInformationGroupSource";
import { HisInfoUserGroupInputBehaviorFactory } from "../groupInput/behavior";
import { Section } from "../../document";

export class HisItemSelectAction implements IHisItemAction, IHisItemSelectable {
  applicableItems: IHisInformationApplicable[][];
  informationItems: HisInformationItem[];
  dateFormat?: string;
  managerIds: string[];
  selectedHisItemSets: IHisItemSet[];

  constructor(private document: IDocumentEditable, item: IHisInformationApplicable, source: IHisInformationGroupSource, itemSetId: number) {
    if (source.data === null) { // クリア処理
      this.applicableItems = this.getApplicableSameGroupItems(item, x => false, itemSetId);
      this.informationItems = [ new HisInformationItem(item.hisItemParameter.key, "") ];
    } else {
      const behavior = HisInfoUserGroupInputBehaviorFactory.create(item, source);
      this.applicableItems = this.getApplicableSameGroupItems(item, (x: IHisInformationApplicable) => behavior.areSameGroup(x), itemSetId);
      this.informationItems = behavior.createHisInfoItems();
      this.dateFormat = (source instanceof HisInformationListItemGroupSource) ? source.dateFormat : null;
    }
    this.selectedHisItemSets = this.toHisItemSets(source);
    this.managerIds = this.getManagerIds(item, source);
  }

  private getManagerIds(item: IHisInformationApplicable, source: IHisInformationGroupSource): string[] {
    if (item.hisItemParameter.key === "WORKFLOW_MANAGE_OPERATOR" && source instanceof HisInformationUserGroupSource) {
      return (source.data != null)
         ? source.data.map(u => u.id)
         : []; // ワークフロー対応責任者がクリアされるとき、指定医番号もクリアする
    }
    return null;
  }

  private getApplicableSameGroupItems(item: IHisInformationApplicable, isLinked: (x: IHisInformationApplicable) => boolean, itemSetId: number): IHisInformationApplicable[][] {
    // 異なるitemSet間でprivateId比較してしまっている処理があり危険なので、同じitemSet内でだけ連動するように暫定対策している
    const currentItemSet = this.document.itemSets[itemSetId];

    const itemSets = this.document.itemSets;
    const items = itemSets.map(itemSet => ((itemSet === currentItemSet) ? itemSet.items : [])
      .filter(instanceOfIHisInformationApplicable)
      .filter(i => !i.shouldInputFree)  // フリー入力状態のオブジェクトには反映させない
      .filter(x => {
        if (x.privateId === item.privateId) { // 選択された項目自身は当然同じグループ
          return true;
        }
        return x.isHisInfo // HIS項目で
          && this.areSameGroupName(x, item) // 同じグループ名称で
          && this.areSamePage(x, item)        // 同じページにあり、
          && isLinked(x);                     // 連動する対象なら同じグループ
      }));
    return items;
  }

  private areSameGroupName(item1: IHisInformationApplicable, item2: IHisInformationApplicable): boolean {
    return !this.stringNullOrEmpty(item1.groupName)
      && !this.stringNullOrEmpty(item2.groupName)
      && (item1.groupName === item2.groupName);
  }

  private areSamePage(item1: IItem, item2: IItem): boolean {
    const sections = this.document.sections;
    return this.getItemPageNumber(item1, sections) === this.getItemPageNumber(item2, sections);
  }

  private stringNullOrEmpty(text: string): boolean {
    return (text == null) || (text === "");
  }

  private getItemPageNumber(item: IItem, sections: Section[]): number {
    for (let i = 0; i < sections.length; i++) {
      const section = sections[i];
      if (section.itemPrivateIds.indexOf(item.privateId) >= 0) {
        return i;
      }
    }
    return -1;
  }

  private toHisItemSets(source: IHisInformationGroupSource): IHisItemSet[] {
    if (source instanceof HisInformationUserGroupSource) {
      return [
        {
          screenKind: ScreenKinds.Doctor,
          items: source.data,
        },
        {
          screenKind: ScreenKinds.Department,
          items: source.department ? [source.department] : null,
        },
      ];
    }
    if (source instanceof HisInformationDepartmentGroupSource) {
      return [
        {
          screenKind: ScreenKinds.Department,
          items: source.data,
        },
      ];
    }
    if (source instanceof HisInformationListItemGroupSource) {
      return [
        {
          screenKind: ScreenKinds.List,
          items: source.data,
        },
      ];
    }
    return null;
  }
}
